import { render } from "./BaseSelect.vue?vue&type=template&id=2457cdce&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=2457cdce&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2457cdce"]])

export default __exports__